import React from "react";

import { dFlex, flex1 } from "./styles";
import Paper from "./Paper";
import { panelHeaderStyle } from "./OnePanel";

const TwoPanels = ({ title1, title2, children }) => (
  <div style={dFlex}>
    <Paper style={{ ...flex1, marginRight: "20px" }}>
      <h1 style={{ ...panelHeaderStyle, marginBottom: "3em" }}>{title1}</h1>
      {children[0]}
    </Paper>
    <Paper style={flex1}>
      <h1 style={panelHeaderStyle}>{title2}</h1>
      {children[1]}
    </Paper>
  </div>
);

export default TwoPanels;



// WEBPACK FOOTER //
// ./src/components/analysis/TwoPanels.js